(function () {
  "use strict";

  /* Runs in the CAPTURE phase, so it always fires before the existing
     bubble-phase ATC click handler in custom-product-grid.js — regardless
     of which script loads first. This guarantees stale size-chart
     link/subheading elements are cleared out before that handler decides
     whether to add new ones for the current product. */
  document.addEventListener(
    "click",
    function (e) {
      var atcBtn = e.target.closest(".cpg-card__atc");
      if (!atcBtn || atcBtn.disabled) return;

      var drawerBody = document.getElementById("cpg-drawer-body");
      if (!drawerBody || !drawerBody.parentNode) return;

      var existingLink = drawerBody.parentNode.querySelector(
        ".cpg-drawer-size-chart-link"
      );
      if (existingLink) existingLink.remove();

      var existingSub = drawerBody.parentNode.querySelector(
        ".cpg-drawer-size-chart-subheading"
      );
      if (existingSub) existingSub.remove();
    },
    true // capture = true
  );
})();
